/* eslint-disable react/prop-types */
//
import React from 'react';
import { connect } from 'react-redux';
import compose from 'utils/compose';

import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import QButton from 'components/QButton';
import { withStyles } from 'tss-react/mui';

import { rootUiActions } from 'app-components/flux/root-ui';
import StdDialog, { isDialogCloseAction } from 'components/Dialogs/StdDialog';

import { styles } from './styles';

export { DIALOG_TYPE, mkConfirmationDialogProps } from './types';

const CONTENT_VIEWS = {};

export const registerContentView = (key, component) => {
  CONTENT_VIEWS[key] = component;
};

class ConfirmationDialog extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      confirmButtonDisabled: Boolean(props.textEntryConfirmationText),
    };
  }

  handleTextEntryConfirmation = (event) => {
    const { textEntryConfirmationText } = this.props;
    this.setState({ confirmButtonDisabled: event.target.value !== textEntryConfirmationText });
  };

  handleClose = (event, dEvent) => {
    const {
      tertiaryAction,
      confirmAction,
      contentViewId,
      denyAction,
      dialogCloseAliasAction,
      dispatch,
      onClose,
      unregisterContentViewOnClose,
    } = this.props;

    const accepted = onClose?.(event, dEvent);

    if (
      (dEvent === 'CONFIRM' || (dialogCloseAliasAction === 'CONFIRM' && isDialogCloseAction(dEvent))) &&
      confirmAction
    ) {
      if (typeof confirmAction === 'function') {
        confirmAction(dEvent, event);
      } else {
        dispatch(confirmAction);
      }
    }
    if ((dEvent === 'DENY' || (dialogCloseAliasAction === 'DENY' && isDialogCloseAction(dEvent))) && denyAction) {
      if (typeof denyAction === 'function') {
        denyAction(dEvent, event);
      } else {
        dispatch(denyAction);
      }
    }
    if (
      (dEvent === 'APPLY_TO_ALL' || (dialogCloseAliasAction === 'APPLY_TO_ALL' && isDialogCloseAction(dEvent))) &&
      tertiaryAction
    ) {
      if (typeof tertiaryAction === 'function') {
        tertiaryAction(dEvent, event);
      } else {
        dispatch(tertiaryAction);
      }
    }

    if (accepted !== false) {
      this.props.removeDialog(this.props.dialogId);

      if (contentViewId && unregisterContentViewOnClose) {
        delete CONTENT_VIEWS[contentViewId];
      }
    }
  };

  render() {
    const {
      classes,
      content,
      contentViewId,
      confirmLabel,
      denyAction,
      denyLabel,
      tertiaryAction,
      tertiaryLabel,
      textEntryConfirmationText,
      confirmButtonVariant,
      denyButtonVariant,
      tertiaryLabelVariant,
      hideBackdrop,
      confirmStartIcon,
      size,
      dispatch,
      confirmAction,
      removeDialog,
      unregisterContentViewOnClose,
      dialogCloseAliasAction,
      onClose: _onClose, // passing this through StdDialog leads to handleClose never being called
      ...otherProps
    } = this.props;
    const { confirmButtonDisabled } = this.state;
    const isString = typeof this.props.content === 'string';
    return (
      <StdDialog
        // TODO: Ken
        onClose={this.handleClose}
        open
        sharedcomponentid={this.props.sharedcomponentid || 'DIALOG_CONFIRMATION'}
        showCloseButton
        title={this.props.title}
        hideBackdrop={hideBackdrop}
        size={size ? size : 'sm'}
        {...otherProps}
      >
        <DialogContent>
          {content && isString && (
            <Typography variant='bodyRegular' id='confirmation-dialog-description' sx={{ whiteSpace: 'pre-line' }}>
              {content}
            </Typography>
          )}
          {!isString && content}

          {contentViewId && CONTENT_VIEWS[contentViewId]}
          {textEntryConfirmationText && (
            <TextField
              autoFocus
              className={classes.confirmationTextField}
              id='text-confirmation'
              label={`Type ${textEntryConfirmationText} to confirm`}
              onChange={this.handleTextEntryConfirmation}
            />
          )}
        </DialogContent>
        <DialogActions>
          {tertiaryLabel && (
            <QButton
              className={classes.tertiary}
              variant={tertiaryLabelVariant || 'delete'}
              id={`confirm-${tertiaryLabel}`}
              disableOutline
              onClick={(event) => this.handleClose(event, 'APPLY_TO_ALL')}
            >
              {tertiaryLabel}
            </QButton>
          )}
          {denyLabel && (
            <QButton
              variant={denyButtonVariant || 'outlined'}
              id={`confirm-${denyLabel}`}
              onClick={(event) => this.handleClose(event, 'DENY')}
              color='primary'
            >
              {denyLabel}
            </QButton>
          )}
          <QButton
            variant={confirmButtonVariant || 'contained'}
            id={`confirm-${confirmLabel}`}
            disabled={confirmButtonDisabled}
            onClick={(event) => this.handleClose(event, 'CONFIRM')}
            startIcon={confirmStartIcon ?? null}
          >
            {confirmLabel}
          </QButton>
        </DialogActions>
      </StdDialog>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    removeDialog: (props) => dispatch(rootUiActions.removeDialog(props)),
    dispatch,
  };
}

export default compose(connect(null, mapDispatchToProps))(
  withStyles(ConfirmationDialog, styles, { name: 'ConfirmationDialog' }),
);
